import { InjectionToken } from '@angular/core';

export interface AuthConfig {
  tokenStorageKey: string;
  authHeader: string;
  gatewayLoginUrl: string;
  tokenExchangeUrl: string;
}

export interface AppConfig {
  appName: string;
  apiBaseUrl: string;
  environment: 'dev' | 'qa' | 'uat' | 'prod';
  enableI18n: boolean;
  announcementBanner: string;
  auth: AuthConfig;
}

export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG');
